//components
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './lib/Components/Navbar.js';

//pages
import Home from './lib/Pages/Home.jsx'; 
import Contact from './lib/Pages/Contact.jsx'; 
import Account from './lib/Pages/AccountPage/Account.jsx';
import NSNSearch from './lib/Pages/NSNSearchPage/NSNSearch.jsx';
import CageSearch from './lib/Pages/CageSearchPage/CageSearch.jsx';
import Forecast from './lib/Pages/ForecastPage/Forecast.jsx';
import Login from './lib/Pages/Login/LoginTest.js';
import Signup from './lib/Pages/Signup/SignupInfo.jsx';
import Register from './lib/Pages/Signup/Register.jsx';
import CheckoutPage from './lib/Pages/Signup/Checkout/CheckoutPage.jsx';
import ReturnPage from './lib/Pages/Signup/Checkout/returnPage.jsx';
import ResetPassword from'./lib/Pages/resetPassword/resetPassword.jsx';


function App() {
  return (
    <div className="App"> 
      <BrowserRouter>
        <Navbar />
          <div className="Pages">
            <Routes>
              <Route path="/" Component = {Home} />
              <Route path="/Contact" Component={Contact} />
              <Route path="/NSNSearch" Component={NSNSearch}/>
              <Route path="/CageSearch" Component={CageSearch}/>
              <Route path="/Forecast" Component={Forecast}/>
              <Route path="/Account" Component={Account}/> 
              <Route path="/Login" Component={Login}/> 
              <Route path="/Signup" Component={Signup}/>
              <Route path="/Register" Component={Register}/>
              <Route path="/CheckoutPage" Component={CheckoutPage}/>
              <Route path="/checkout/return" Component={ReturnPage}/>
              <Route path="/resetPassword" Component={ResetPassword}/>
            
            </Routes>
          </div>
        
      </BrowserRouter>
      
    </div>
  );
};



export default App;